/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompanyInfoVo } from './CompanyInfoVo';
import {
    CompanyInfoVoFromJSON,
    CompanyInfoVoFromJSONTyped,
    CompanyInfoVoToJSON,
    CompanyInfoVoToJSONTyped,
} from './CompanyInfoVo';

/**
 * 
 * @export
 * @interface AdminUpdateUserReqVo
 */
export interface AdminUpdateUserReqVo {
    /**
     * 用户id
     * @type {number}
     * @memberof AdminUpdateUserReqVo
     */
    id?: number;
    /**
     * 用户姓名 韩文
     * @type {string}
     * @memberof AdminUpdateUserReqVo
     */
    name?: string;
    /**
     * 用户姓名 英文
     * @type {string}
     * @memberof AdminUpdateUserReqVo
     */
    nameEn?: string;
    /**
     * 会员编号
     * @type {string}
     * @memberof AdminUpdateUserReqVo
     */
    code?: string;
    /**
     * 会员等级id
     * @type {number}
     * @memberof AdminUpdateUserReqVo
     */
    gradeId?: number;
    /**
     * 登录账号
     * @type {string}
     * @memberof AdminUpdateUserReqVo
     */
    account?: string;
    /**
     * 电话号码
     * @type {string}
     * @memberof AdminUpdateUserReqVo
     */
    mobileNo?: string;
    /**
     * 电子邮箱
     * @type {string}
     * @memberof AdminUpdateUserReqVo
     */
    emailPrefix?: string;
    /**
     * 电子邮箱域名
     * @type {string}
     * @memberof AdminUpdateUserReqVo
     */
    emailDomain?: string;
    /**
     * 是否是开发票 0 不开 1 开
     * @type {number}
     * @memberof AdminUpdateUserReqVo
     */
    vat?: number;
    /**
     * 推荐码
     * @type {string}
     * @memberof AdminUpdateUserReqVo
     */
    recommendCode?: string;
    /**
     * 是否启用 0 不启用 1 启用
     * @type {number}
     * @memberof AdminUpdateUserReqVo
     */
    enable?: number;
    /**
     * 韩国钱包透支额度（兼容原字段）
     * @type {number}
     * @memberof AdminUpdateUserReqVo
     */
    overdraftLimit?: number;
    /**
     * 客户商业类型  1 企业 2 个人
     * @type {number}
     * @memberof AdminUpdateUserReqVo
     */
    businessType?: number;
    /**
     * 钱包充值货币类型  目前只有韩币和人民币两种
     * @type {string}
     * @memberof AdminUpdateUserReqVo
     */
    walletCurrencyCode?: string;
    /**
     * 是否接收邮件  0 不接收， 1 接收  默认1
     * @type {number}
     * @memberof AdminUpdateUserReqVo
     */
    emailReceive?: number;
    /**
     * 是否接收短信  0 不接收， 1 接收  默认1
     * @type {number}
     * @memberof AdminUpdateUserReqVo
     */
    smsReceive?: number;
    /**
     * 是否接收kakao信息  0 不接收， 1 接收  默认1
     * @type {number}
     * @memberof AdminUpdateUserReqVo
     */
    kakaoReceive?: number;
    /**
     * 备注
     * @type {string}
     * @memberof AdminUpdateUserReqVo
     */
    remark?: string;
    /**
     * 最后登录时间
     * @type {string}
     * @memberof AdminUpdateUserReqVo
     */
    lastLoginTime?: string;
    /**
     * 注册时间
     * @type {string}
     * @memberof AdminUpdateUserReqVo
     */
    createTime?: string;
    /**
     * 韩国钱包余额（兼容原字段）
     * @type {string}
     * @memberof AdminUpdateUserReqVo
     */
    walletBalance?: string;
    /**
     * 韩国钱包预存款余额
     * @type {string}
     * @memberof AdminUpdateUserReqVo
     */
    koreaWalletBalance?: string;
    /**
     * 中国钱包预存款余额
     * @type {string}
     * @memberof AdminUpdateUserReqVo
     */
    chinaWalletBalance?: string;
    /**
     * 韩国钱包透支额度
     * @type {number}
     * @memberof AdminUpdateUserReqVo
     */
    koreaOverdraftLimit?: number;
    /**
     * 中国钱包透支额度
     * @type {number}
     * @memberof AdminUpdateUserReqVo
     */
    chinaOverdraftLimit?: number;
    /**
     * 积分
     * @type {number}
     * @memberof AdminUpdateUserReqVo
     */
    point?: number;
    /**
     * 密码
     * @type {string}
     * @memberof AdminUpdateUserReqVo
     */
    password?: string;
    /**
     * 
     * @type {CompanyInfoVo}
     * @memberof AdminUpdateUserReqVo
     */
    chineseCompanyInfo?: CompanyInfoVo;
    /**
     * 韩国公司信息
     * @type {Array<CompanyInfoVo>}
     * @memberof AdminUpdateUserReqVo
     */
    koreanCompanyInfo?: Array<CompanyInfoVo>;
}

/**
 * Check if a given object implements the AdminUpdateUserReqVo interface.
 */
export function instanceOfAdminUpdateUserReqVo(value: object): value is AdminUpdateUserReqVo {
    return true;
}

export function AdminUpdateUserReqVoFromJSON(json: any): AdminUpdateUserReqVo {
    return AdminUpdateUserReqVoFromJSONTyped(json, false);
}

export function AdminUpdateUserReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminUpdateUserReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'nameEn': json['nameEn'] == null ? undefined : json['nameEn'],
        'code': json['code'] == null ? undefined : json['code'],
        'gradeId': json['gradeId'] == null ? undefined : json['gradeId'],
        'account': json['account'] == null ? undefined : json['account'],
        'mobileNo': json['mobileNo'] == null ? undefined : json['mobileNo'],
        'emailPrefix': json['emailPrefix'] == null ? undefined : json['emailPrefix'],
        'emailDomain': json['emailDomain'] == null ? undefined : json['emailDomain'],
        'vat': json['vat'] == null ? undefined : json['vat'],
        'recommendCode': json['recommendCode'] == null ? undefined : json['recommendCode'],
        'enable': json['enable'] == null ? undefined : json['enable'],
        'overdraftLimit': json['overdraftLimit'] == null ? undefined : json['overdraftLimit'],
        'businessType': json['businessType'] == null ? undefined : json['businessType'],
        'walletCurrencyCode': json['walletCurrencyCode'] == null ? undefined : json['walletCurrencyCode'],
        'emailReceive': json['emailReceive'] == null ? undefined : json['emailReceive'],
        'smsReceive': json['smsReceive'] == null ? undefined : json['smsReceive'],
        'kakaoReceive': json['kakaoReceive'] == null ? undefined : json['kakaoReceive'],
        'remark': json['remark'] == null ? undefined : json['remark'],
        'lastLoginTime': json['lastLoginTime'] == null ? undefined : json['lastLoginTime'],
        'createTime': json['createTime'] == null ? undefined : json['createTime'],
        'walletBalance': json['walletBalance'] == null ? undefined : json['walletBalance'],
        'koreaWalletBalance': json['koreaWalletBalance'] == null ? undefined : json['koreaWalletBalance'],
        'chinaWalletBalance': json['chinaWalletBalance'] == null ? undefined : json['chinaWalletBalance'],
        'koreaOverdraftLimit': json['koreaOverdraftLimit'] == null ? undefined : json['koreaOverdraftLimit'],
        'chinaOverdraftLimit': json['chinaOverdraftLimit'] == null ? undefined : json['chinaOverdraftLimit'],
        'point': json['point'] == null ? undefined : json['point'],
        'password': json['password'] == null ? undefined : json['password'],
        'chineseCompanyInfo': json['chineseCompanyInfo'] == null ? undefined : CompanyInfoVoFromJSON(json['chineseCompanyInfo']),
        'koreanCompanyInfo': json['koreanCompanyInfo'] == null ? undefined : ((json['koreanCompanyInfo'] as Array<any>).map(CompanyInfoVoFromJSON)),
    };
}

export function AdminUpdateUserReqVoToJSON(json: any): AdminUpdateUserReqVo {
    return AdminUpdateUserReqVoToJSONTyped(json, false);
}

export function AdminUpdateUserReqVoToJSONTyped(value?: AdminUpdateUserReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'nameEn': value['nameEn'],
        'code': value['code'],
        'gradeId': value['gradeId'],
        'account': value['account'],
        'mobileNo': value['mobileNo'],
        'emailPrefix': value['emailPrefix'],
        'emailDomain': value['emailDomain'],
        'vat': value['vat'],
        'recommendCode': value['recommendCode'],
        'enable': value['enable'],
        'overdraftLimit': value['overdraftLimit'],
        'businessType': value['businessType'],
        'walletCurrencyCode': value['walletCurrencyCode'],
        'emailReceive': value['emailReceive'],
        'smsReceive': value['smsReceive'],
        'kakaoReceive': value['kakaoReceive'],
        'remark': value['remark'],
        'lastLoginTime': value['lastLoginTime'],
        'createTime': value['createTime'],
        'walletBalance': value['walletBalance'],
        'koreaWalletBalance': value['koreaWalletBalance'],
        'chinaWalletBalance': value['chinaWalletBalance'],
        'koreaOverdraftLimit': value['koreaOverdraftLimit'],
        'chinaOverdraftLimit': value['chinaOverdraftLimit'],
        'point': value['point'],
        'password': value['password'],
        'chineseCompanyInfo': CompanyInfoVoToJSON(value['chineseCompanyInfo']),
        'koreanCompanyInfo': value['koreanCompanyInfo'] == null ? undefined : ((value['koreanCompanyInfo'] as Array<any>).map(CompanyInfoVoToJSON)),
    };
}

